import { AppColors } from "@/styles/colors";
import { Menu, Portal } from "@chakra-ui/react";
import { ReactNode } from "react";

interface Props {
  trigger: ReactNode;
  items: {
    label: string;
    value: string;
    action: () => void;
  }[];
  placement?:
    | "top-start"
    | "top-end"
    | "right-start"
    | "right-end"
    | "bottom-start"
    | "bottom-end"
    | "left-start"
    | "left-end";
}

export const MenuComponent = ({
  items,
  trigger,
  placement = "right-start",
}: Props) => {
  return (
    <Menu.Root positioning={{ placement }}>
      <Menu.Trigger asChild>{trigger}</Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content bgColor={AppColors.WHITE_SECONDARY} padding="12px">
            {items?.map((el) => (
              <Menu.Item
                key={el?.value}
                value={el?.value}
                cursor="pointer"
                onClick={el?.action}
                color={AppColors.BLACK_TEXT_SECONDARY}
                paddingX="4px"
                paddingY="6px"
                _hover={{
                  bgColor: AppColors.WHITE_BORDER_1,
                }}
              >
                {el?.label}
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
